<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('tel42')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="search">
                <div class="searchleft">
                    <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                        <el-form-item :label="$t('phone')">
                            <el-input v-model="searchform.phone" @keyup.enter.native="onSubmit" size="small"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <el-table :data="list" @current-change="handleCurrentChange" 
                        :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="phone" :label="$t('phone')">
                            <template slot-scope="scope">
                                <el-link type="primary" @click="dial(scope.row.phone, 0)">
                                    {{scope.row.phone}}
                                </el-link>
                            </template>
                        </el-table-column>
                        <el-table-column prop="level" :label="$t('createTime')">
                            <template slot-scope="scope">
                                {{scope.row.createTime|changedate}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="platform" :label="$t('pingt')"></el-table-column>
                        <el-table-column prop="isAuth" :label="$t('status')"></el-table-column>
                        <el-table-column prop="jobName" :label="$t('operator')" width="150">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="审核" placement="top">
                                     <el-button size="small" @click="openadd(scope.row)" type="primary" icon="el-icon-circle-check" circle plain></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <app-page :total="total" :current="pageNo" :pageSize="pageSize"
                            @handleCurrentChange="currentchange" @handleSizeChange="handchange"></app-page>
                    </div>
                </div>
                <div class="listleft">
                    <el-tabs type="border-card">
                        <el-tab-pane :label="$t('jbxx')">
                            <div class="orderdiv" style="margin-top: 8px;">
                                <div class="formbox" style="width:750px;">
                                    <h2 style="margin-bottom:10px;">{{$t('sfxx')}}</h2>
                                    <el-form ref="form" :model="form" label-width="130px">
                                        <el-form-item :label="$t('idCardPositive')">
                                            <div class="block">
                                                <el-image :src="form.idCardPositive">
                                                <div slot="placeholder" class="image-slot">
                                                    {{$t('jzz')}}<span class="dot">...</span>
                                                </div>
                                                </el-image>
                                            </div>
                                        </el-form-item>
                                        <el-form-item :label="$t('idCardReverse')">
                                            <div class="block">
                                                <el-image :src="form.idCardReverse">
                                                <div slot="placeholder" class="image-slot">
                                                    {{$t('jzz')}}<span class="dot">...</span>
                                                </div>
                                                </el-image>
                                            </div>
                                        </el-form-item>
                                        <el-form-item :label="$t('faceUrl')">
                                            <div class="block">
                                                <el-image :src="form.faceUrl">
                                                <div slot="placeholder" class="image-slot">
                                                    {{$t('jzz')}}<span class="dot">...</span>
                                                </div>
                                                </el-image>
                                            </div>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
        <pop-up :title="$t('o8')" :isshow="showadd" :haveconfirm="true" @close="getclose" @confirm="getconfirm">
            <div slot="box" style="width: 400px;">
                <el-form ref="form" :inline="true" :model="checkForm" :rules="rules" size="small" label-width="240px">
                    <el-form-item :label="$t('c1')">
                        <el-radio-group v-model="checkForm.va1">
                            <el-radio :label="1">si</el-radio>
                            <el-radio :label="2">no</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
        </pop-up>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    phone: null,
                    mchOrderNo: null,
                    userName: null,
                    createTime: null,
                    exclusiveLinks:null,
                    stats: null,
                    idCardPositive:null,
                },
                checkForm: {
                    userId: null,
                    va1: null,
                },
                searchform: {
                    blurry: "",
                },
                loading: false,
                showadd: false,
                list: [],
                value1:[],
                searchform:{},
                total: 1,
                pageNo: 1,
                pageSize: 10,
                user:null,
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
        },
        methods: {
            dial(row, row1) {
                _api.get(apiurl.dial, {
                    phone: row,
                    type: row1,
                    nation: localStorage.getItem("nation"),
                }).then(res => {
                    alert(res.message);
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    })
                })
            },
            openadd(row) {
                this.showadd = true
                this.checkForm = {
                    userId: this.currentRow,
                    va1: null,
                }
            },
            handleCurrentChange(val) {
                this.currentRow = val.id;
                this.getDetail();
            },
            getconfirm() {
                _api.post(apiurl.cardcheck, this.checkForm)
                .then(res => {
                    this.$notify.success({
                        title: this.$t('success'),
                        message: this.$t('addSuccess')
                    })
                    this.getList()
                    this.showadd = false
                    this.checkForm = {
                        userId: this.currentRow,
                        va1: null,
                    }
                }).catch(err => {
                    this.$notify.error({
                        title: this.$t('error'),
                        message: err.data.message
                    })
                })
            },

            getList() {
                this.loading = true
                _api.get(apiurl.myUserAuth, {
                    page: this.pageNo,
                    size: this.pageSize,
                    phone: this.searchform.phone,
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.loading = false
                    this.list = res.content.data
                    this.total = res.content.totalCount
                })
            },
           
            getDetail(){
                _api.get(apiurl.userInfo,{userId:this.currentRow}).then(res=>{
                    this.form.idCardPositive=res.data.idCardPositive
                    this.form.idCardReverse=res.data.idCardReverse
                    this.form.faceUrl=res.data.faceUrl
                });
            },
            
            getclose() {
                this.$refs.form.resetFields();
                this.showadd = false
            },

            onSubmit() {
                this.pageNo = 1
                this.getList()
            },

            handchange(data) { //分页Size变化
                this.pageSize = data
                this.pageNo = 1
                this.getList()
            },

            currentchange(data) { //当前页变化
                this.pageNo = data
                this.getList()
            },
        }
    }
</script>
<style scoped>
    
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .orderdiv{
        display: flex;
        border-style: ridge;
        border-bottom: 1px solid #EBEEF5;
    }

    .listleft {
        width: 50%;
        margin-left: 0.5%;
    }

    body .el-table th.gutter{
        display: table-cell!important;
    }

    .listright {
        width: 50%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }
    .formbox{ padding:15px 0; margin-top: 10px;}

    .listrighttop span {
        float: right;
    }
    .toptj{ display: flex; margin:15px 0;}
    .tjitem{ 
        flex: 1; 
        background: #ffffff; 
        cursor: pointer; 
        border: #ebedf0 solid 1px; 
        height: 60px; 
        margin-right: 10px;
        padding: 8px 12px;
        text-align: center;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>